module.exports = __webpack_public_path__ + "img/activemydocs.99418d93.svg";